<template>
  <el-form
    label-width="160px"
    label-position="left"
    :show-message="false"
    @submit.native.prevent
    :model="form"
    ref="form"
  >
    <el-form-item label="网站名称" prop="title" required>
      <zt-input max-width="340px" v-model="form.title"></zt-input>
      <p class="help">*2至10个字符，1个中文计为1个字符</p>
    </el-form-item>

    <el-form-item label="网站域名" prop="domain">
      <el-radio-group v-model="domainTypeModel">
        <el-radio v-if="cms_info.domain_type === 1 && isBuyPluginDomain" :label="1">插件域名</el-radio>
        <el-radio :label="2">免费域名</el-radio>
        <el-radio :label="3">自有域名</el-radio>
      </el-radio-group>
      <!-- 插件域名 -->
      <div v-if="domainTypeModel === 1 && isBuyPluginDomain">
        <div>
          <div class="less-input">{{domainPluginFull}}</div>
          <span class="copy-btn" v-copy="domainPluginFull">复制</span>
        </div>
        <div class="help-warn">将于 {{pluginDomain.expires}} 过期</div>
        <div class="help">过期后不再支持续费，请及时更换为自有域名</div>
      </div>
      <!-- 免费域名 -->
      <div v-if="domainTypeModel === 2">
        <div v-if="cms_info.domain_type === 2">
          <div class="less-input">{{domainFreeFull}}</div>
          <span class="copy-btn" v-copy="domainFreeFull">复制</span>
        </div>
        <div class="help-warn">免费域名有被微信封的风险，为了保证您的cms正常运营，请及时更换为自有域名</div>
      </div>
      <!-- 自有域名 -->
      <div v-if="domainTypeModel === 3">
        <div>
          <zt-input max-width="340px" v-model="domainSelfModel">
            <el-select v-model="form.ssl" slot="prepend" class="select">
              <el-option label="http://" :value="0"></el-option>
              <el-option v-if="radio!='2'" label="https://" :value="1"></el-option>
            </el-select>
          </zt-input>
          <span class="copy-btn" v-copy="domainSelfFull">复制</span>
        </div>
        <p class="help-link">
          <app-link class="link" to="https://mp.weixin.qq.com/s/5GiYBv9aDMAbA3jU6MkjGQ">如何配置域名</app-link>
        </p>
      </div>
    </el-form-item>

    <el-form-item label="快站域名">
      <!-- <zt-input width="340px" disabled :value="$store.getters.cms_info.home_page_url"/> -->
      <div class="less-input">{{ $store.getters.cms_info.home_page_url }}</div>
      <span class="copy-btn" v-copy="$store.getters.cms_info.home_page_url">复制</span>
    </el-form-item>

    <el-form-item label="授权证书(.crt文件)" required v-if="form.ssl == 1">
      <el-upload
        action
        class="upload-demo"
        ref="upload"
        :on-remove="()=> { form.sslcrt = '' }"
        :on-change="(file)=> { handleUploadchange('sslcrt',file) }"
        :auto-upload="false"
        :multiple="false"
        :limit="1"
        accept="crt"
      >
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      </el-upload>
      <p class="help">*阿里云是.pem</p>
    </el-form-item>

    <el-form-item label="授权证书(.key文件)" required v-if="form.ssl == 1">
      <el-upload
        action
        class="upload-demo"
        ref="upload"
        :on-remove="()=> { form.sslkey = '' }"
        :on-change="(file)=> { handleUploadchange('sslkey',file) }"
        :auto-upload="false"
        :multiple="false"
        :limit="1"
        accept="key"
      >
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      </el-upload>
    </el-form-item>

    <!-- <el-form-item label="HTTPS协议" prop="ssl">
      <el-switch v-model="form.ssl" :active-value="1" :inactive-value="0"></el-switch>
      <p class="help">*需要购买ssl证书才可以正常使用https协议</p>
    </el-form-item>-->

    <!-- <el-form-item label="快站域名" prop="share_domain">
      <zt-input max-width="340px" v-model="form.share_domain"></zt-input>
      <p class="help">*选择快站域名服务作为cms分享网址，此举极大提高cms域名的安全性</p>
    </el-form-item>-->

    <el-form-item label="网站LOGO">
      <upload :selecteds.sync="logoModel" :is-catch="false" />
      <p class="help">
        *支持jpg或png格式。建议Logo比例1:4，尺寸不小于80*30px，单个文件不能超过50kb
        <!-- <a href="#" target="_blank">快速生成网站logo</a> -->
      </p>
    </el-form-item>

    <el-form-item label="网站ICO">
      <upload :selecteds.sync="icoMdodel" :is-catch="false" />
      <p class="help">
        *只能上传jpg/png格式文件，图片比例1:1, 要求尺寸不小于32*32px，单个文件不能超过50kb。将显示在浏览器标签页。
        <span
          class="link"
          @click="(icoExampleVisible=true)"
        >查看示例</span>
        <!-- <a href="#" target="_blank">快速生成网站logo</a> -->
      </p>
    </el-form-item>

    <el-form-item label="客服微信" prop="wx" required>
      <zt-input max-width="340px" v-model="form.wx"></zt-input>
    </el-form-item>

    <el-form-item label="客服QQ" prop="qq" required>
      <zt-input max-width="340px" v-model="form.qq"></zt-input>
    </el-form-item>


    <el-form-item label="网站备案号" prop="icpno" v-if="domainTypeModel === 3">
      <el-radio-group v-model="radio" @change="radioChange">
        <el-radio label="1">我有备案</el-radio>
        <el-radio label="2">我没有备案</el-radio>
      </el-radio-group>
      <div>
        <zt-input v-if="radio=='1'" max-width="340px" v-model="form.icpno"></zt-input>
      </div>
    </el-form-item>

    <el-form-item label="淘宝客私域用户管理" v-if="vip >= 2">
      <el-switch :value="form.cms_tksy" :active-value="1" :inactive-value="0" @change="changeTksy" />
      <p class="help">
        *已在阿里妈妈申请淘宝客私域用户管理权限的淘客，可开启该功能。
        <app-link class="link" to="https://mp.weixin.qq.com/s/Ici5KsVSGcUP0IIR9PN6aw">《私域用户管理介绍》</app-link>
      </p>
    </el-form-item>

    <el-form-item label="是否自动成为代理 " v-if="vip >= 3">
      <el-switch
        v-model="form.cms_member_allow_agent_auto_join"
        :active-value="1"
        :inactive-value="0"
      ></el-switch>
      <p class="help">*开启后，用户授权淘宝成功，或用户主动点击申请，都可立即成为代理</p>
    </el-form-item>

    <el-form-item label="申请成为代理入口 " v-if="vip >= 3">
      <el-switch v-model="form.cms_member_allow_agent_apply" :active-value="1" :inactive-value="0"></el-switch>
      <p class="help">*将在cms个人中心显示申请成为代理按钮</p>
    </el-form-item>

    <el-form-item label="是否开启自动跟单 " v-if="vip >= 2">
      <!-- <el-radio-group v-model="form.assign_order_by_trade_last6code">
        <el-radio :label="1">会员授权自动跟单</el-radio>
        <el-radio :label="0">使用订单后六位</el-radio>
        <el-radio :label="2">不跟单</el-radio>
      </el-radio-group>-->
      <el-switch
        v-model="form.assign_order_by_trade_last6code"
        :active-value="1"
        :inactive-value="0"
      ></el-switch>
      <p
        class="help"
      >*自动跟单是指利用淘宝订单号后6位进行会员绑定，来弥补无法通过私域会员id来拉取订单的问题。（如不需要跟单，请不要开启此开关以及清除pid管理中私域会员专用pid。）</p>
    </el-form-item>

    <el-form-item label="是否注册必填邀请码 ">
      <!-- <el-radio-group v-model="form.assign_order_by_trade_last6code">
        <el-radio :label="1">会员授权自动跟单</el-radio>
        <el-radio :label="0">使用订单后六位</el-radio>
        <el-radio :label="2">不跟单</el-radio>
      </el-radio-group>-->
      <el-switch v-model="form.reg_invcode_require" :active-value="1" :inactive-value="0"></el-switch>
      <!-- <p class="help">*自动跟单是指利用淘宝订单号后6位进行会员绑定，来弥补无法通过私域会员id来拉取订单的问题。（如不需要跟单，请不要开启此开关以及清除pid管理中私域会员专用pid。）</p> -->
    </el-form-item>

    <zt-button type="primary" @click.enter.exact="onSubmit" min-width="140px">保存</zt-button>

    <el-dialog ref="icoExample" title="查看示例" :visible.sync="icoExampleVisible">
      <img :src="img_ico_example" />
    </el-dialog>
  </el-form>
</template>

<script>
import Upload from '@cps/Upload';
import infoMixin from '../mixins/info';
import img_ico_example from '@imgs/img_ico_example.png';
import { mapGetters } from 'vuex';
import { copy } from '@/directive/copy';
export default {
  name: 'CMSWebSiteConfigBase',
  mixins: [infoMixin],
  directives: { copy },
  components: { Upload },

  data: () => ({
    form: {
      title: '', // 网站标题
      domain: '', // 网站域名
      sslcrt: '', // .crt文件(ssl时是使用)
      sslkey: '', // .key文件(ssl时是使用)
      logo: '', // logo
      ico: '', // ico
      wx: '', // 微信客服
      qq: '', // qq
      icpno: '', // 备案信息
      ssl: '', // HTTPS域名
      cms_tksy: 0,
      cms_member_allow_agent_apply: 1,
      cms_member_allow_agent_auto_join: 0,
      assign_order_by_trade_last6code: 1, //1为开启自动跟单
      reg_invcode_require: 0, //邀请码是否为必填
    },
    radio: '1',
    logoModel: [], // logo 模型
    icoMdodel: [], // ico 模型
    tklPidReadonly: true, // 淘口令pid输入框只读状态
    cmsPidReadonly: true, // cms pid输入框只读状态
    domainTypeModel: 0, // 网站域名选项 0没 1插件 2免费 3自定义
    domainSelfModel: '',
    icoExampleVisible: false,
    img_ico_example,
  }),

  computed: {
    ...mapGetters(['user_info']),
    ...mapGetters(['cms_info']),
    ...mapGetters(['pluginDomain']),

    // 是否购买了插件
    isBuyPluginDomain: (vm) => vm.pluginDomain.plugin_domain_expires_at > parseInt(Date.now() / 1000),

    // 插件域名
    domainPluginFull: (vm) => `http://${vm.cms_info.domain}`,

    // 免费域名
    domainFreeFull: (vm) => `http://${vm.cms_info.domain}`,

    // 自有域名
    domainSelfFull: (vm) => `${vm.form.ssl === 0 ? 'http://':'https://'}${vm.domainSelfModel}`,

    // 当前vip等级:   1 导购版 2用户中心版 3返利代理版 4尊享版
    vip: (vm) => vm.user_info.vip,
  },

  watch: {
    'form.logo': {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.logoModel = val
            .split(',')
            .filter((v) => v)
            .map((item) => {
              return {
                id: new Date() * Math.random(),
                src: item,
                selected: true,
              };
            });
        }
      },
    },
    'form.ico': {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.icoMdodel = val
            .split(',')
            .filter((v) => v)
            .map((item) => {
              return {
                id: new Date() * Math.random(),
                src: item,
                selected: true,
              };
            });
        }
      },
    },

    'cms_info.domain_type': {
      immediate: true,
      deep: true,
      handler(val) {
        this.domainTypeModel = val
        if(val === 3) {
          this.domainSelfModel = this.form.domain
        }
      },
    },

    'form.domain': {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.domainTypeModel === 3) {
          this.domainSelfModel = val
        }else {
          this.domainSelfModel = ''
        }
      },
    },

    logoModel(val) {
      this.form.logo = val.map((item) => item.src).join(',');
    },
    icoMdodel(val) {
      this.form.ico = val.map((item) => item.src).join(',');
    },
  },

  methods: {
    radioChange(e) {
      if (e == '2') {
        this.form.ssl = 0;
      }
    },
    onEditPid(key) {
      this[key + 'PidReadonly'] = false;
    },
    onLoadFile(file) {
      window.file = file;
    },
    handleUploadPreview() {},
    handleUploadRemove() {},
    handleUploadchange(key, file) {
      this.form[key] = file.raw;
    },

    // 切换 - 淘宝客私域用户管理
    changeTksy(val) {
      this.$confirm(
        '确认是否关闭(开启)私域用户管理，以下改动将影响订单拉取，请谨慎操作。'
      ).then(() => {
        this.form.cms_tksy = val;
        if (val) {
          this.$alert('请到联盟设置补充私域渠道专用PID和会员专用PID');
        }
      });
    },

    // 提交前数据转换
    submitBeforeTransform(form) {
      // 如果是免费域名提交空
      if(this.domainTypeModel === 2) {
        form.domain = ''
      }
      if(this.domainTypeModel === 3) {
        form.domain = this.domainSelfModel
      }
      return form
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "~@/styles/form.scss";

.select {
  width: 100px;
}

.link {
  font-size: 12px;
  color: $theme;
  cursor: pointer;
}

// 修改pid
.edit {
  color: $theme;
  margin-left: 16px;
  cursor: pointer;
}

.zt-input /deep/ {
  .zt-input__inner[readonly] {
    border-color: transparent;
  }
}

// pid失效样式 div.pid-failure
// .pid-failure {
//   .zt-input /deep/ .zt-input__inner {
//     background: #FFFCCF;
//   }
// }

.help {
  a {
    color: $theme;
  }
}

.copy-btn {
  color: $theme;
  cursor: pointer;
  margin-left: 8px;
}

div.less-input {
  display: -webkit-inline-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;

  width: 340px;
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
  border-radius: 2px;
  border: 1px solid #e4e7ed;
  vertical-align: middle;
  padding: 0 7px;
  box-sizing: border-box;
  word-break: break-all;
}
</style>
